import React, {useEffect, useState} from "react";

import VLFModal from "@/components/Modal";
import VLFTextField from "@/components/Input/TextField";

import {REQUIRED_FIELD} from "@/utils/constants";
import {checkRequiredFields} from "@/utils/functions";

const requiredFields = ["name"];

function HandleContactModal(props) {
	const {open, initialData, confirm, close} = props;

	const [formData, setFormData] = useState({});
	const [errors, setErrors] = useState([]);

	useEffect(() => {
		if (initialData) {
			setFormData(initialData);
		}
	}, [initialData]);

	useEffect(() => {
		if (!open) {
			setFormData({});
		}
	}, [open]);

	return (
		<VLFModal
			maxWidth="md"
			open={open}
			title={initialData ? "Modifica informazione" : "Aggiungi informazione"}
			close={close}
			confirm={() => {
				const errors = checkRequiredFields(requiredFields, formData);
				setErrors(errors);

				if (!errors.length) {
					confirm(formData, initialData?.id);
				}
			}}
			content={
				<div className="row">
					<div className="col-xs-12 col-sm-6">
						<VLFTextField
							name="name"
							value={formData.name || ""}
							onChange={(event) => {
								setErrors([]);
								setFormData({...formData, name: event.target.value});
							}}
							label="Nome"
							size="small"
							helperText={errors.indexOf("name") !== -1 ? REQUIRED_FIELD : ""}
							error={errors.indexOf("name") !== -1}
						/>
					</div>
					<div className="col-xs-12 col-sm-6">
						<VLFTextField
							name="email"
							value={formData.email || ""}
							onChange={(event) => {
								setFormData({...formData, email: event.target.value});
							}}
							label="Email"
							size="small"
						/>
					</div>
					<div className="col-xs-12 col-sm-6">
						<VLFTextField
							name="telephone"
							value={formData.telephone || ""}
							onChange={(event) => {
								setFormData({...formData, telephone: event.target.value});
							}}
							label="Telefono"
							size="small"
							type="phone"
						/>
					</div>
					<div className="col-xs-12 col-sm-6">
						<VLFTextField
							name="relation"
							value={formData.relation || ""}
							onChange={(event) => {
								setFormData({...formData, relation: event.target.value});
							}}
							label="Parentela"
							size="small"
						/>
					</div>
				</div>
			}
		/>
	);
}

export default HandleContactModal;
